$.WorkflowProgress = function(options) {
	var segment = $('<div class="ui segment workflowStateProgress">')[0];

	$.extend(segment, {
		createProgress: function() {
			this.workflow.workflow_item_states.numberSort('position');
			var header = $('<div class="ui center aligned header">').text(this.workflow.name);
			var subHeader = $('<div class="sub header">').text(this.workflow.description);
			header.append(subHeader);

			var ul = $('<ul class="progress-indicator">');
			for(let i = 0; i < this.workflow.workflow_item_states.length; i++) {
				var step = this.workflow.workflow_item_states[i];

				if(step.viewable_by_suborganizations || $.OrgRole != 'customer_role') {
					var li = this.createStep(step);
					$(ul).append(li);
				}
			}

			$(this).append(header).append(ul);
		},
		createStep: function(step) {
			var li = $('<li>');
			li.data('step', step);

			var bubble = $('<span class="bubble">');
			li.append(bubble);

			var text = $('<span>').text(step.name);
			if(step.due) {
				var dueLine = $('<span>').text(moment(step.due).format('MMMM Do'));
				dueLine.prepend('<i class="calendar icon">');
				text.append(dueLine);
			}
			li.append(text);
			this.setupStepCompletion(li, step);

			return li;
		},
		setupStepCompletion: function(li, step) {
			if(step.completed_at) {
				li.addClass('completed');

				var completed = $('<span>').text(moment(step.completed_at).format('MMMM Do'));
				if(step.completed_by_user && step.completed_by_user.name) {
					li.attr('data-tooltip', 'Completed by ' + step.completed_by_user.name);
				}
				completed.prepend('<i class="checkmark icon"/>');
				li.append('<br>').append(completed);
			} else if(this.workflow.active_workflow_item_id == step.workflow_item_id) {
				li.addClass('active');

				if(step.condition_source == 'organization_condition_source' && (step.condition_allows_suborganizations != !$.isCustomer)) {
					var complete = $('<span>');
					var completeButton = $('<div class="ui tiny green labeled icon button"><i class="checkmark icon"/>Mark Done</div>').click(function () {
						completeButton.addClass('loading');
						$.plicAPI({
							method: 'workflow-states/' + step.workflow_state_id + '/complete-item',
							type: 'PATCH',
							params: {
								workflow_item_state_id: step.workflow_item_state_id
							},
							success: function (data) {
								complete.text(moment().format('MMMM Do'));
								li.attr('data-tooltip', 'Completed by ' + $.CurrentUser.name);
								var nextLi = li.next();
								if(nextLi.length) {
									var nextStep = nextLi.data('step');
									segment.workflow.active_workflow_item_id = nextStep.workflow_item_id;
									segment.setupStepCompletion(nextLi, nextStep);
								}
								li.removeClass('active').addClass('completed');
							},
							error: function () {
								$.Alert('Error', 'Failed to mark step as completed');
								completeButton.removeClass('loading');
							}
						});
					}).appendTo(complete);
					li.append('<br>').append(complete);
				}
			}
		}
	}, options);

	if(segment.workflow) {
		segment.createProgress();
	}

	return segment;
};

$.WorkflowAddDetailsToState = function(workflows, states) {
	var workflowsById = {};
	for(let i = 0; i < workflows.length; i++) {
		let workflow = workflows[i];

		var itemsById = {};
		for(let j = 0; j < workflow.workflow_items.length; j++) {
			let item = workflow.workflow_items[j];
			itemsById[item.id] = item;
		}
		workflow.workflow_items = itemsById;

		workflowsById[workflow.id] = workflow;
	}

	for(let i = 0; i < states.length; i++) {
		var state = states[i];
		let workflow = workflowsById[state.workflow_id];
		state.name = workflow.name;
		state.description = workflow.description;

		for(let j = 0; j < state.workflow_item_states.length; j++) {
			var itemState = state.workflow_item_states[j];
			let item = workflow.workflow_items[itemState.workflow_item_id];

			if(item.retired_at) {
				state.workflow_item_states.splice(j, 1);
				j--;
			} else {
				itemState.workflow_item_state_id = itemState.id;
				$.extend(itemState, item);
				delete itemState.id;
			}
		}
	}
};

$.WorkflowStep = function(step) {
	return $.extend({
		getCompletedBy: function() {
			for(var name in this.completedByMap) {
				var settings = this.completedByMap[name];

				var matched = true;
				for(var settingName in settings) {
					if(this.step[settingName] !== settings[settingName] && settingName != 'condition_plic_app_id') {
						matched = false;
						break;
					}
				}

				if(matched) {
					return name;
				}
			}

			return null;
		},
		convertCompletedBy: function() {
			$.extend(this.step, this.completedByMap[this.step.completedBy]);
			delete this.step.completedBy;
		},
		completedByMap: {
			rootOrgUser: {
				condition_source: 'organization_condition_source',
				condition_allows_suborganizations: false
			},
			customerOrgUser: {
				condition_source: 'organization_condition_source',
				condition_allows_suborganizations: true
			},
			subjectsUploaded: {
				condition_source: 'plic_app_project_condition_source',
				condition_plic_app_id: $.plicSlug,
				condition_project_action: 'book_imported'
			},
			startedWorkBook: {
				condition_source: 'plic_app_project_condition_source',
				condition_plic_app_id: $.plicSlug,
				condition_project_action: 'book_opened'
			},
			submittedBook: {
				condition_source: 'plic_app_project_condition_source',
				condition_plic_app_id: $.plicSlug,
				condition_project_action: 'book_submitted'
			},
			startedWorkElement: {
				condition_source: 'plic_app_project_condition_source',
				condition_plic_app_id: $.plicSlug,
				condition_project_action: 'element_opened'
			},
			submittedElement: {
				condition_source: 'plic_app_project_condition_source',
				condition_plic_app_id: $.plicSlug,
				condition_project_action: 'element_submitted'
			}
		},
		step: step
	});
};